import { generateCompanySlug } from '@/lib/company-utils';
import type { Locale } from '@/lib/i18n-routes';
import type { LiveEvent } from './live-map-engine';

/** The company page of a ticker entry: /de/unternehmen/freiburg/HRB728943/…. */
export function liveEventHref(e: LiveEvent, locale: Locale): string {
  return generateCompanySlug(
    { name: e.name, registerCourt: e.registerCourt, registerType: e.registerType, registerId: e.registerId },
    locale,
  );
}
